import { useMemo } from 'react';
import { MTable } from '@Components/Base';
import { TableProps } from 'antd';
import { NoData } from '@Components/RequestList/noData';
import { ViewResolver } from '@Components/ViewResolver';
import {
  MaterialRequisitionDocumentResponse,
  MaterialRequisitionItemFormResponse,
} from '@Types/api/form';

import { ViewTab } from '../../../ViewTab.enum';
import DetailsTab from './DetailsTab/DetailsTab';
import MaterialTabItemMobile from './components/MaterialTabItemMobile/MaterialTabItemMobile';
import DocumentTabItemMobile from './components/DocumentTabItemMobile/DocumentTabItemMobile';
import { ColumnSettings, ResponseListType } from '../../types';
import {
  ColumnDocumentDataType,
  ColumnMaterialDataType,
} from '../../DataSource/type';

import styles from './content-confirmation.module.css';

interface ContentConfirmationResolverProps {
  activeTab: string;
  columnSettings: ColumnSettings;
  dataSource: ColumnMaterialDataType[] | ColumnDocumentDataType[];
  dataList: ResponseListType | undefined;
  columns: TableProps['columns'] | null;
  onDeleteItems: () => void;
}

const ContentConfirmationResolver: React.FC<
  ContentConfirmationResolverProps
> = ({
  activeTab,
  columnSettings,
  dataSource,
  columns,
  dataList,
  onDeleteItems,
}) => {
  const renderTab = useMemo(() => {
    if (activeTab === ViewTab.MATERIALS && dataList) {
      return (
        <MaterialTabItemMobile
          dataSource={dataList as MaterialRequisitionItemFormResponse[]}
        />
      );
    }
    if (activeTab === ViewTab.DOCUMENTS && dataList) {
      return (
        <DocumentTabItemMobile
          dataSource={dataList as MaterialRequisitionDocumentResponse[]}
        />
      );
    }

    return <NoData context="confirmation" />;
  }, [activeTab, dataList]);

  if (activeTab === ViewTab.DETAILS) {
    return <DetailsTab />;
  }

  if (!columns || !dataSource) {
    return <NoData context="confirmation" />;
  }

  return (
    <ViewResolver
      desktop={
        <MTable
          title={
            columnSettings?.isSelected
              ? () => columnSettings?.renderColumnHeader(onDeleteItems)
              : undefined
          }
          rowSelection={columnSettings?.rowSelection}
          columns={columns}
          dataSource={dataSource}
          hidePagination
        />
      }
      mobile={<div className={styles.mobileLayout}>{renderTab}</div>}
    />
  );
};

export default ContentConfirmationResolver;
